import { Icon, IconProps } from "@chakra-ui/react";

function AttachedFileIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.33326 11.3333C8.69113 11.8118 9.14772 12.2077 9.67205 12.4941C10.1964 12.7806 10.7762 12.9509 11.3721 12.9936C11.9681 13.0363 12.5662 12.9503 13.126 12.7415C13.6858 12.5327 14.1942 12.2059 14.6166 11.7833L17.1166 9.28334C17.8756 8.4975 18.2956 7.44499 18.2861 6.35251C18.2766 5.26002 17.8384 4.21497 17.0658 3.44243C16.2933 2.6699 15.2482 2.2317 14.1558 2.2222C13.0633 2.21271 12.0108 2.63269 11.2249 3.39168L9.79159 4.81668M11.6666 9.66668C11.3087 9.18824 10.8521 8.79236 10.3278 8.50589C9.80347 8.21943 9.22367 8.04908 8.62771 8.0064C8.03176 7.96372 7.4336 8.04971 6.8738 8.25853C6.314 8.46735 5.80566 8.79412 5.38326 9.21668L2.88326 11.7167C2.12426 12.5025 1.70429 13.555 1.71378 14.6475C1.72327 15.74 2.16148 16.7851 2.93401 17.5576C3.70655 18.3301 4.7516 18.7683 5.84408 18.7778C6.93657 18.7873 7.98908 18.3673 8.77492 17.6083L10.1999 16.1833"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default AttachedFileIcon;
